module.exports = __webpack_public_path__ + "img/macroOff.8e5d37ae.png";